import {OfferType} from "../../offer/types/OfferType";
import {AdditionalAreaType} from "../../property/utils/get_additional_area_type";
import {IClientUpdatePayload} from "../api/for_you_client";
import {IForYouModal} from "../types/IForYouModal";

export const getUpdateData = (modalState: IForYouModal): IClientUpdatePayload => {
    const additionalCriteria = modalState.additional;
    const regionsData = modalState.regions?.map((region) => region.id);
    const additionalAreaSelected = additionalCriteria?.additional_areas && additionalCriteria.additional_areas;

    return {
        regions: regionsData || [],
        additional_areas:
            additionalAreaSelected && additionalAreaSelected.toString() !== "0"
                ? additionalAreaSelected.toString() === AdditionalAreaType.BALCONY.toString()
                    ? [additionalAreaSelected, AdditionalAreaType.LOGGIA]
                    : [additionalAreaSelected]
                : [],
        comments: additionalCriteria?.comments || "",
        construction_end_date: additionalCriteria?.date || undefined,
        floors: additionalCriteria?.floor,
        kitchen_type: (additionalCriteria?.kitchen && parseInt(additionalCriteria?.kitchen)) || undefined,
        quarters: additionalCriteria?.quarters || undefined,
        types: modalState.types.length ? modalState.types : [OfferType.FLAT, OfferType.HOUSE],
        distance: modalState.distance
    };
};
import {OfferType} from "../../offer/types/OfferType";
import {AdditionalAreaType} from "../../property/utils/get_additional_area_type";
import {IClientUpdatePayload} from "../api/for_you_client";
import {IForYouModal} from "../types/IForYouModal";

export const getUpdateData = (modalState: IForYouModal): IClientUpdatePayload => {
    const additionalCriteria = modalState.additional;
    const regionsData = modalState.regions?.map((region) => region.id);
    const additionalAreaSelected = additionalCriteria?.additional_areas && additionalCriteria.additional_areas;

    return {
        regions: regionsData || [],
        additional_areas:
            additionalAreaSelected && additionalAreaSelected.toString() !== "0"
                ? additionalAreaSelected.toString() === AdditionalAreaType.BALCONY.toString()
                    ? [additionalAreaSelected, AdditionalAreaType.LOGGIA]
                    : [additionalAreaSelected]
                : [],
        comments: additionalCriteria?.comments || "",
        construction_end_date: additionalCriteria?.date || undefined,
        floors: additionalCriteria?.floor,
        kitchen_type: (additionalCriteria?.kitchen && parseInt(additionalCriteria?.kitchen)) || undefined,
        quarters: additionalCriteria?.quarters || undefined,
        types: modalState.types.length ? modalState.types : [OfferType.FLAT, OfferType.HOUSE],
        distance: modalState.distance
    };
};
